import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from '@/app/providers/AppProvider';
import { AdminApp } from '@/pages/admin/AdminApp';
import { ToastContainer } from '@/components/feedback/ToastContainer';
import { SessionNoticeHost } from '@/components/feedback/SessionNoticeHost';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import '@/shared/styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Root backstop: catches crashes outside the routed area (login/signup
        screens, the layout shell, provider tree) that the per-route boundary
        in AdminLayout cannot reach. */}
    <ErrorBoundary>
      <AppProvider>
        <AdminApp />
        <ToastContainer />
        {/* Involuntary session-end notice (duplicate login). Mounted beside the toast
            container so it outlives the interceptor's logout redirect. */}
        <SessionNoticeHost />
      </AppProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
